// extracted by mini-css-extract-plugin
export default {"footerHolder":"footerHolder--tiJEl","footerContent":"footerContent--OQswX","animation-bzdot9":"animation-bzdot9--RK8EC"};